import { Component, OnInit, Inject } from '@angular/core';

import { DatePipe } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-confirm-ngn-dialog',
    templateUrl: './confirm-ngn-dialog.component.html',
    styleUrls: ['./confirm-ngn-dialog.component.scss']
})
export class ConfirmNGNDialogComponent implements OnInit {
    account_expiration: any;
    transfer_reference: any;
    transfer_bank: any;
    transfer_account: any;
    transfer_note: any;
    transfer_amount: any;
    mode: any;

    constructor(public dialogRef: MatDialogRef<ConfirmNGNDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
    }

    ngOnInit() {
        ;
        this.transfer_reference = this.data.transfer_reference;
        this.transfer_account = this.data.transfer_account;
        this.transfer_bank = this.data.transfer_bank;
        this.account_expiration = this.data.account_expiration;
        this.transfer_note = this.data.transfer_note;
        this.transfer_amount = this.data.transfer_amount;
        this.mode = this.data.mode;
    }

    done() {
        this.dialogRef.close();
    }

    closeModal() {
        this.dialogRef.close();
    }
}
